import React from "react";

function FieldSection({ children }) {
  return <div style={{ paddingLeft: 24, paddingRight: 24 }}>{children}</div>;
}

export default FieldSection;
